export default interface MoneyDTO {
  amount: string;
  currency: string;
  subunit: number;
}

export const isZero = (money: MoneyDTO): boolean => {
  return money.amount === '0'
}